import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Haibao extends React.PureComponent {
    static propTypes = {
        handleMaskHide: PropTypes.func,
    };

    state = {
        haibaoImg: '',
        isShow: false,
    };

    componentDidMount() {
        this.handleScreen();
    }

    handleScreen = async () => {
        let html2canvas = await import(/* webpackChunkName: "html2canvas" */ 'html2canvas');

        html2canvas = html2canvas.default;

        const el = document.querySelector('#share');

        html2canvas(el, {
            useCORS: true,
            width: el.offsetWidth - 1,
            height: el.offsetHeight - 1,
            scrollX: 0,
            scrollY: 0,
            scale: 4,
        }).then(canvas => {
            const context = canvas.getContext('2d');

            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            this.setState({
                haibaoImg: canvas.toDataURL(),
                isShow: true,
            });

            if (window.grounds) {
                window.grounds.shareWebCard(
                    canvas.toDataURL().replace('data:image/png;base64', ''),
                    JSON.stringify({
                        shareurl: '自定义卡片分享',
                        title: '自定义卡片分享',
                        desc: '自定义卡片分享',
                        thumbnail: '自定义卡片分享',
                        documentId: '自定义卡片分享',
                        timestamp: '自定义卡片分享',
                    }),
                );
                this.props.handleMaskHide();
            }
        });
    };

    render() {
        const { haibaoImg, isShow } = this.state;
        const { handleMaskHide } = this.props;

        return (
            window.grounds ? null : <div className={styles.mask}>
                <div className={styles.share_hb}>
                    {isShow &&
                        <>
                            <img src={haibaoImg} /><div className={styles.tip}>长按保存图片</div>
                        </>
                    }
                </div>
                <div id="close" className={styles.close} onClick={handleMaskHide} />
            </div>
        );
    }
}

export default errorBoundary(Haibao);
